import React from 'react'
import "./Furniture.css"
import Product from "../Components/Product"
import prd1 from "../images/mask1.jpeg"
import prd2 from "../images/mask2.jpeg"
import prd3 from "../images/mask3.jpeg"
import prd4 from "../images/mask4.jpeg"
import prd5 from "../images/mask5.jpeg"
import prd6 from "../images/mask6.jpeg"
import prd7 from "../images/mask7.jpeg"
import prd8 from "../images/mask8.jpeg"
import prd9 from "../images/mask9.jpeg"
import prd10 from "../images/mask10.jpeg"
import prd11 from "../images/mask11.jpeg"
import prd12 from "../images/mask12.jpeg"
import prd13 from "../images/mask13.jpeg"
import prd14 from "../images/mask14.jpeg"
import prd15 from "../images/mask15.jpeg"
export default function Furniture() {
    return (
        <div>
            <div className="main">

                <div className="prd_row1">
                    <Product id="mask1" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd1} price="Price : ₹10,820 " review="5.5" ></Product>
                    <Product id="mask2" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd2} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="mask3" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd3} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="mask4" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd4} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="mask5" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd5} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="mask6" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd6} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="mask7" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd7} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="mask8" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd8} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                


            </div>
            <div className="main1">

                <div className="prd_row1">
                    <Product id="mask9" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd9} price=" ₹10,820  25% off" review="5.5" ></Product>
                    <Product id="mask10" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd10} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="mask11" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd11} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="mask12" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd12} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="mask13" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd13} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="mask14" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB  " img={prd14} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                <div className="prd_row2">
                    <Product id="mask15" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd15} price=" Price : ₹ 5580" review="5.5" ></Product>
                    <Product id="mask16" prdName="Hexton HM-COMBO-1-BWGB N95 HM-COMBO-1-BWGB " img={prd1} price=" Price : ₹ 5580" review="5.5" ></Product>
                </div>
                


            </div>

        </div>
    )
}
